import React, { createContext, useContext, useEffect, useState } from 'react';
import io from 'socket.io-client';
import { useAuth } from '../auth/AuthContext';

const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
  const { dbUser } = useAuth(); // 👈 access the authenticated user here

  const [notifications, setNotifications] = useState([]);

  const triggerNotification = (notification) => {
    // If notification includes forceId and a notification with same id is already being rendered, skip
    if (notification.forceId) {
      if (notifications.find(n => n.forceId == notification.forceId)) {
        console.log('Notification skipped due to: Already being rendered');
        return;
      }
    }

    setNotifications((prev) => [...prev, notification]);

    if (notification.sound) {
      const audio = new Audio('/notificationsound.mp3');
      audio.play().catch((error) => { });
    }

    if (document.visibilityState !== 'visible' && Notification.permission === 'granted') {
      new Notification('🔔 Notificación', {
        body: notification.message,
        icon: '/logo192.png',
        // actions: [
        //   { action: 'open', title: 'Open App' },
        //   { action: 'dismiss', title: 'Dismiss' },
        // ],
        requireInteraction: true, // keeps notification visible until user acts (optional)
      });
    }

    // Determine the display time. Default to 4000ms if not provided or invalid.
    const displayTime = typeof notification.time === 'number' && notification.time > 0 ? notification.time : 4000;

    setTimeout(() => {
      setNotifications((prev) => prev.slice(1));
    }, displayTime); // Use the dynamic displayTime here
  };

  useEffect(() => {
    if (Notification.permission !== 'granted') {
      Notification.requestPermission();
    }

    const socket = io('https://bluejims.com:5005', {
      transports: ['websocket', 'polling'],
    });

    socket.on('connect', () => {
      console.log('🟢 Socket connected:', socket.id);
      // Identify with user email if available
      if (dbUser?.email) {
        socket.emit('identify', dbUser.email);
        console.log('dbUser.email?', dbUser.email);
        // socket.emit('pulse', { message: '🔔 Hello from client!' });
      }
    });

    socket.on('notification', async (data) => {
      console.log('📨 Incoming notification:', data);
      await dbUser?.update();
      triggerNotification(data);
      console.log('Notification triggered!');
      
    });

    return () => socket.disconnect();
  }, [dbUser?.email]);

  // Handle user interaction with notification
  const handleNotificationClick = (note, index) => {
    console.log('note', note, 'index', index);

    const cat = note.cat;
    //
    if (cat == 'received-request-from-group') {

    }
  };

  return (
    <NotificationContext.Provider value={{ triggerNotification }}>
      {children}
      {/* Top notification container */}
      <div style={styles.container}>
        {notifications.map((note, index) => (
          <div
            onClick={() => { handleNotificationClick(note, index); }}
            key={index}
            style={{
              ...styles.notification,
              // Aplica estilos de error si 'isError' es true
              ...(note.isError && styles.errorNotification),
              animationDelay: `${index * 1}s`,
            }}
          >
            <div style={styles.icon}>{note.isError ? '⚠️' : '🔔'}</div> {/* Cambia el icono si es un error */}
            <div style={styles.message}>{note.message}</div>
          </div>
        ))}
      </div>

      {/* CSS Animations */}
      <style>{`
        @keyframes slideDownFadeIn {
          0% {
            opacity: 0;
            transform: translateY(-120%);
          }
          10% {
            opacity: 1;
            transform: translateY(0);
          }
          90% {
            opacity: 1;
            transform: translateY(0);
          }
          100% {
            opacity: 0;
            transform: translateY(-120%);
          }
        }
      `}</style>
    </NotificationContext.Provider>
  );
};

const styles = {
  container: {
    position: 'fixed',
    top: 40,
    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: 9999,
    display: 'flex',
    flexDirection: 'column',
    gap: '14px',
    pointerEvents: 'none',
    width: '100%',
    maxWidth: 400,
    padding: '0 20px',
  },
  notification: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: '16px 24px',
    background:
      'rgba(255, 255, 255, 0.85)', // translucent white
    backdropFilter: 'blur(20px)', // frosted glass blur effect
    borderRadius: 20,
    boxShadow:
      '0 8px 32px 0 rgba(0, 0, 0, 0.15)', // subtle shadow
    color: '#000',
    fontSize: 18,
    fontWeight: '600',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
    textAlign: 'left',
    pointerEvents: 'auto',
    animation: 'slideDownFadeIn 4s ease forwards',
    userSelect: 'none',
  },
  // Nuevo estilo para notificaciones de error
  errorNotification: {
    background: 'rgba(255, 0, 0, 0.75)', // Rojo semi-transparente
    color: '#fff', // Texto blanco para mayor contraste
  },
  icon: {
    fontSize: 26,
  },
  message: {
    flex: 1,
  },
};

export const useNotification = () => {
  const context = useContext(NotificationContext);
  if (!context) throw new Error('useNotification must be used within NotificationProvider');
  return context;
};